import axiosInstance from "../../axios/axiosInstance";
import { GET_ALL_AUTO_NOTIFICATION, SCHEDULE_AUTO_NOTIFICATIONS, TOGGLE_AUTO_NOTIFICATION_STATUS, UPLOAD_BULK_AUTO_NOTIFICATIONS } from "../../constants";

// api/context/analytics.js
export const getAllNotification = (params) => onResponse => {
    try {
        axiosInstance.get(GET_ALL_AUTO_NOTIFICATION, {
            params: params // Send as query parameters
        })
        .then((response) => {
            onResponse(response.data);
        })
        .catch((err) => {
            console.log(err)
            onResponse(err);
        });
    } catch (error) {
        console.error(error);
    }
};

export const uploadBulkAutoNotifications = (props) => (onResponse) => {
  try {
    let BASE_URL = UPLOAD_BULK_AUTO_NOTIFICATIONS;
    axiosInstance
      .post(BASE_URL, props)
      .then((response) => {
        onResponse(response);
      })
      .catch((err) => {
        onResponse(err.response);
      });
  } catch (error) { }
};

export const scheduleAutoNotification = (props) => (onResponse) => {
  try {
    let BASE_URL = SCHEDULE_AUTO_NOTIFICATIONS;
    axiosInstance
      .post(BASE_URL, props)
      .then((response) => {
        onResponse(response);
      })
      .catch((err) => {
        onResponse(err.response);
      });
  } catch (error) { }
};

export const toggleAutoNotificationStatus = (id) => onResponse => {
    try {
        axiosInstance.post(TOGGLE_AUTO_NOTIFICATION_STATUS, { id })
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });
    } catch (error) {
        onResponse({ error: true, message: error.message });
    }
};